export default __webpack_public_path__ + "static/media/Bumper.392b239e.png";